import { NavigationContextProvider } from "../components/navbar_context.jsx";
import Navbar from "../components/navbar.jsx";

const NavbarWrapper = () => {
  return (
    <NavigationContextProvider>
      <Navbar />
    </NavigationContextProvider>
  );
};

export default NavbarWrapper;
